import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { EmojiStore } from '../../../ui/emoji';
import { EditorSession } from '../../canvas/EditorSession';
import { Physicals } from '../../canvas/entities/Physicals';
import { Selection } from '../../canvas/Selection';
import { alert } from '../alerts/AlertCommands';
import { Tag } from '../annotations/Tag';
import { Sticky } from '../paper/Sticky';
import { Zone } from './Zone';
import { ZoneAssocation } from './ZoneAssociations';

export const createZone = defineCommand(
    'createZone',
    'Create: Zone',
    (r) => {
        Physicals.createAtCameraPosition(r, Zone, nc => {
            nc.width = 800;
            nc.height = 600;
        });
    },
);

export const selectionApplyZones = defineCommand(
    'selectionApplyZones',
    'Selection: Apply Zones',
    r => {

        const dispatch = r.call(CommandDispatcher);
        const objects = r.call(ObjectManager);
        const session = r.call(EditorSession);

        const stickies = Physicals.polarize(session.get(Selection), Sticky);
        if (!stickies.length) return;

        let count = 0;

        objects.update(u => {

            for (const st of stickies) {
                const zn = objects.getMaybe(ZoneAssocation.get(st), Zone);
                if (!zn) continue;

                st.background = zn.autoColor;

                const emoji = EmojiStore.find(zn.emoji);
                const zt = u.create(Tag);
                zt.name = zn.title.toUpperCase();
                zt.symbol = emoji?.value || '';
                zt.color = zn.autoColor || Tag.pickColor(zt.name);
                st.add(zt);

                count++;
            }

        });

        dispatch(alert, [`Applied zone color and emoji to ${count} stickies.`]);
    }
);
